import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { HelpdeskTaskPriorityEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk.task.priority.enum';

export const HelpdeskPriorityI18nEnum: Record<I18nLocalesEnum, Record<HelpdeskTaskPriorityEnum, string>> = {
  [I18nLocalesEnum.RU_RU]: {
    [HelpdeskTaskPriorityEnum.HIGH]: 'Высокий',
    [HelpdeskTaskPriorityEnum.MEDIUM]: 'Средний',
    [HelpdeskTaskPriorityEnum.LOW]: 'Низкий',
  },
  [I18nLocalesEnum.EN_US]: {
    [HelpdeskTaskPriorityEnum.HIGH]: 'High',
    [HelpdeskTaskPriorityEnum.MEDIUM]: 'Medium',
    [HelpdeskTaskPriorityEnum.LOW]: 'Low',
  },
};
